<script lang="ts" setup>
import { AvatarComp, DropdownComp } from '@/components';
import { UserDao } from '@/dao';
import { DropdownItemButton, DropdownItemSeparator } from '@/objects';
import router from '@/router';

import { useUserStoreRef } from '@/stores';

const props = defineProps({
    disablemenu: Boolean,
});

const { user } = useUserStoreRef();

/**
 * Logout the user
 */
const logout = () => {
    UserDao.Logout();
    user.value = null;
    router.push({ name: 'root' });
};

const userActions = [
    DropdownItemButton.create({
        translationkey: 'account.myaccount',
        icon: 'fa-user',
        action: () => {
            console.log('My Account');
        },
    }),
    DropdownItemSeparator.create(),
    DropdownItemButton.create({
        translationkey: 'account.logout',
        icon: 'fa-right-from-bracket',
        action: logout,
    }),
];
</script>
<template>
    <div class="user-name text-wrap text-center">{{ user?.Name }}</div>

    <template v-if="disablemenu">
        <div class="user-avatar">
            <AvatarComp />
        </div>
    </template>

    <DropdownComp
        :show-arrow="false"
        button-type="Custom"
        auto-close="outside"
        class="no-focus user-avatar"
        colorclass=""
        v-if="!disablemenu"
        :dropdownItems="userActions"
    >
        <template v-slot:closedContent>
            <span class="text-center">
                <AvatarComp />
            </span>
        </template>
    </DropdownComp>
</template>
